import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ColorModeProvider } from '@/stores/ColorModeContext';
import { MainErrorFallback } from '@/components/errors/main';
import { AuthProvider } from '@/lib/firebase/auth';
import { ClientProvider } from '@/stores/ClientContext';

const AppProvider = ({ children }) => {
  return (
    <ErrorBoundary FallbackComponent={MainErrorFallback}>
      <AuthProvider>
        <ColorModeProvider>
          <ClientProvider>
            {children}
          </ClientProvider>
        </ColorModeProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
};

export default AppProvider;
